// src/components/review/IntakeDecisionCardList.js
// ADR-032 Fase III — tab "Tabelas de Preço" do Review Workbench. READ-ONLY.
// Lê a view v_intake_decision_card (Grill Me v1) e renderiza um IntakeDecisionCard
// por run price_table. Espelha ErelEntityReviewList (estados loading/empty/error,
// Tailwind slate/blue, lucide-react), sem decisão/RPC/toast — Fase III é só leitura.

import React, { useCallback, useEffect, useState } from 'react';
import { AlertCircle } from 'lucide-react';
import { supabase } from '../../supabaseClient';
import IntakeDecisionCard from './IntakeDecisionCard';

export default function IntakeDecisionCardList({ onLoadedCount }) {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    const { data, error: err } = await supabase
      .from('v_intake_decision_card')
      .select('*')
      .order('run_id', { ascending: true });
    if (err) {
      setError(err.message);
      setCards([]);
      setLoading(false);
      return;
    }
    const rows = data || [];
    setCards(rows);
    setLoading(false);
    if (typeof onLoadedCount === 'function') {
      onLoadedCount(
        rows.filter((r) => (r.bloco_falta?.actions_pendentes_total ?? 0) > 0).length,
      );
    }
  }, [onLoadedCount]);

  useEffect(() => {
    load();
  }, [load]);

  const comPendencias = cards.filter(
    (c) => (c.bloco_falta?.actions_pendentes_total ?? 0) > 0,
  ).length;

  return (
    <div className="space-y-3">
      <div className="text-xs text-slate-600 font-medium">
        {loading ? (
          'Carregando…'
        ) : (
          <>
            <span className="text-sm font-bold text-slate-900">{cards.length}</span>{' '}
            tabela{cards.length === 1 ? '' : 's'} de preço
            {comPendencias > 0 && (
              <span className="ml-2 text-amber-600">
                · {comPendencias} com pendência{comPendencias === 1 ? '' : 's'}
              </span>
            )}
          </>
        )}
      </div>

      {error && (
        <div className="p-3 bg-red-50 border border-red-200 rounded text-xs text-red-800 flex items-start gap-2">
          <AlertCircle size={14} className="flex-shrink-0 mt-0.5" />
          <span>{error}</span>
        </div>
      )}

      {!loading && !error && cards.length === 0 && (
        <div className="bg-white border border-slate-200 rounded-lg p-12 text-center">
          <p className="text-sm text-slate-600">Nenhuma tabela de preço para revisar.</p>
          <p className="text-xs text-slate-400 mt-1">
            Runs price_table roteados para review aparecem aqui (ADR-032 Fase II/II-B).
          </p>
        </div>
      )}

      {!error && cards.map((c) => <IntakeDecisionCard key={c.run_id} card={c} />)}
    </div>
  );
}
